
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.39 2.29L13.14.796l.508-.43 3.82 3.82v.5l-3.82 3.82-.507-.429 1.257-1.508H3.468l1.259 1.508-.508.43-3.82-3.82v-.5l3.82-3.82.508.429-1.25 1.492H14.39zM1.782 4.436l.883 1.094h12.531l.89-1.093-.898-1.11H2.68l-.899 1.11z","fill":"currentColor"}})])
          )
        }
      }
    